import { render, staticRenderFns } from "./PaymentTypeSetting.vue?vue&type=template&id=24225fba"
import script from "./PaymentTypeSetting.vue?vue&type=script&lang=js"
export * from "./PaymentTypeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24225fba')) {
      api.createRecord('24225fba', component.options)
    } else {
      api.reload('24225fba', component.options)
    }
    module.hot.accept("./PaymentTypeSetting.vue?vue&type=template&id=24225fba", function () {
      api.rerender('24225fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/PaymentTypeSetting.vue"
export default component.exports